import Utils from "./utils";

const BY_SPACES = /\s+/;
const SPACE = " ";
const CSS_VENDOR_PREFIXES = ["-webkit-", "-moz-", "-ms-", "-o-"];
/**
 * @class CSSHelpers
 */
class CSSHelpers {

    /**
     * @static
     * @param {Element} element
     * @param {string} className
     * @returns {CSSHelpers}
     */
    static addClass(element, className) {
        if (!element || !className) {
            return this;
        }

        if (element.classList) {
            element.classList.add(className);
            return this;
        }

        const allClasses = element.className ? element.className.trim().split(BY_SPACES) : [];

        if (classIndexInList(allClasses, className) !== -1) {
            return this;
        }

        element.className = allClasses.concat([className]).join(SPACE);

        return this;
    }

    /**
     * @static
     * @param {Element} element
     * @param {Array} classList
     * @returns {CSSHelpers}
     */
    static addClassList(element, classList) {
        if (Utils.isArray(classList)) {
            classList.forEach(function(className) {
                CSSHelpers.addClass(element, className);
            });
        }

        return this;
    }

    /**
     * @static
     * @param {Element} element
     * @param {string} className
     * @returns {CSSHelpers}
     */
    static removeClass(element, className) {
        if (!element) {
            return this;
        }

        if (element.classList) {
            element.classList.remove(className);
            return this;
        }

        const allClasses = element.className ? element.className.trim().split(BY_SPACES) : [];
        const position = classIndexInList(allClasses, className);

        if (position === -1) {
            return this;
        }

        allClasses.splice(position, 1);
        element.className = allClasses.join(SPACE);

        return this;
    }

    /**
     * @static
     * @param {Element} element
     * @param {string} className
     * @returns {?boolean}
     */
    static hasClass(element, className) {
        if (!element) {
            return;
        }

        if (element.classList) {
            return element.classList.contains(className);
        }

        const allClasses = element.className.trim().split(BY_SPACES);
        return (classIndexInList(allClasses, className) !== -1);
    }

    /**
     * @method
     * @param {Element} element
     * @param {string|object} css CSS text or hash of properties to values
     */
    static css(element, css) {
        if (typeof css === "string") {
            element.style.cssText = css;
            return;
        }

        const cssText = Object.keys(css).map((rule) => {
            const normalizedRule = rule.toLowerCase();
            const value = css[rule];

            return `${ normalizedRule }: ${ value };`;
        }).join("");

        if (cssText) {
            element.style.cssText = cssText;
        }
    }

    /**
     * @static
     * @param {Element} element
     * @returns {CssStyle}
     */
    static computedStylesFor(element) {
        return document.defaultView.getComputedStyle(element, "");
    }

    /**
     * @static
     * @param element
     * @param transformation
     */
    static transform(element, transformation) {
        if (element) {
            let transformProperty = "transform";
            if (!(transformProperty in element.style)) {
                for (let i = 0, ii = CSS_VENDOR_PREFIXES.length, prefix; i < ii; i++) {
                    prefix = CSS_VENDOR_PREFIXES[i];
                    transformProperty = prefix + transformProperty;
                    if (transformProperty in element.style) {
                        break;
                    }
                }
            }
            element.style[transformProperty] = transformation;
        }
    }
}

/**
 * @private
 * @param {Array} classNames
 * @param {string} className
 * @returns {number}
 */
function classIndexInList(classNames, className) {
    const arrLength = classNames.length;

    for (let i = 0; i < arrLength; i++) {
        if (className === classNames[i]) {
            return i;
        }
    }

    return -1;
}

export default CSSHelpers;
